import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AuthService } from '../auth/auth.service';
import axiosClient from '../../../shared/axios/axios-client';
import axios from 'axios';

@Injectable({
  providedIn: 'root',
})
export class MoviaService {
  private apiUrl = environment.apiUrl;
  
  constructor(private authService: AuthService, private http: HttpClient) {}

  async gerarUrlUploadAzure(nomeArquivo: string): Promise<any> {
    try {
      const resUrl = await axiosClient.post(
        `${environment.apiUrl}/movia/analise/gerar-url`,
        null,
        { params: { fileName: nomeArquivo } },
      );
      return resUrl;
    } catch (err) {
      console.error('Erro ao buscar histórico: ', err);
    }
  }

  async enviarVideoParaAzure(uploadUrl: string, arquivo: any) {
    await axios.put(uploadUrl, arquivo, {
      headers: {
        'x-ms-blob-type': 'BlockBlob',
        'Content-Type': arquivo.type,
      },
    });
  }

  async iniciarProcessamento(
    uploadUrl: string,
    arquivo: any,
    correlationId: string,
    fileName: string,
    idEstabelecimento: number | null,
    idPessoa: number | null,
    presencaDeCarga: number | null,
  ) {
    const tamanhoMB = arquivo.size / (1024 * 1024);
    const duracaoSEC = await this.obterDuracaoVideo(arquivo);
    const linkBlobstorage = uploadUrl.split('?')[0];
    await axiosClient.post(`${environment.apiUrl}/movia/analise`, {
      correlationId,
      fileName,
      tamanhoMB,
      duracaoSEC,
      linkBlobstorage,
      idEstabelecimento: idEstabelecimento,
      idPessoa: idPessoa,
      presencaDeCarga: presencaDeCarga,
    });
  }

  async buscarHistorico() {
    try {
      const response = await axiosClient.get('/movia/analise/historico');
      return response.data.data;
    } catch (err) {
      console.error('Erro ao buscar histórico: ', err);
    }
  }

  private obterDuracaoVideo(arquivo: File): Promise<number> {
    return new Promise((resolve, reject) => {
      const video = document.createElement('video');
      video.preload = 'metadata';
      video.onloadedmetadata = () => {
        URL.revokeObjectURL(video.src);
        resolve(video.duration);
      };
      video.onerror = reject;
      video.src = URL.createObjectURL(arquivo);
    });
  }

  async baixarRelatorio(correlationId: string): Promise<void> {
    const body = { correlationId };
    try {
      const response = await axiosClient.post('/movia/analise/exportar-csv', body, {
        responseType: 'blob',
      });

      const disposition = response.headers['content-disposition'];
      const nomeArquivo = disposition
          ? disposition.split('filename=')[1]
          : `analise_postural_${new Date().getTime()}.csv`;

      const url = window.URL.createObjectURL(new Blob([response.data], { type: 'text/csv; charset=utf-8' }));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nomeArquivo);
      document.body.appendChild(link);
      link.click();
      
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err: any) {
      console.error('Erro na exportação:', err);
      throw new Error(err?.response?.data?.message || 'Erro ao exportar dados. Verifique sua conexão.');
    }
  }
}
